// import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
import addToCart from './addToCart';
import updateCart from './updateCart';
import updateCartQuantity from './updateCartQuantity';
import { closeMobileNav } from '../header/mobile-nav';
import CartDrawerDiscount from '../../components/cart-discount/cart-drawer-discount';
// import { closeSubnav } from '../header/desktop-nav';

/*
const cartPosition = () => {
  let cart_top = $('.main-nav--desktop').height() + 1;
  if (!$('.no-announcement').length && !$('.main-nav--desktop.sticky').length && !$('.slider-cart-opened').length) {
    cart_top += $('.announcement-bar--desktop').outerHeight();
  }

  $('#shopify-section-slider-cart').css('top', `${cart_top}px`);
};
*/

const getElementHeightWithMargins = (element) => {
  if (!element) return 0;
  const style = window.getComputedStyle(element);
  const marginTop = parseFloat(style.marginTop) || 0;
  const marginBottom = parseFloat(style.marginBottom) || 0;
  return element.offsetHeight + marginTop + marginBottom;
};

const productsAreaHeight = () => {
  const slider_cart = document.querySelector('[data-slider-cart]');
  if (!slider_cart) {
    return;
  }

  const slider_cart_products = slider_cart.querySelector('.slider-cart__products');
  if (!slider_cart_products) {
    return;
  }

  let max_height = '100%';
  const is_mobile = $('.main-nav--mobile').is(':visible');
  const cart_content_element = slider_cart.querySelector('.slider-cart__content');
  const mb_element = slider_cart.querySelector('[data-slider-cart-mb]');
  const discount_element = slider_cart.querySelector('[data-slider-cart-discount-form]');
  const totals_element = slider_cart.querySelector('[data-slider-cart-totals]');
  const buttons_element = slider_cart.querySelector('[data-slider-cart-buttons]');
  const loyalty_guest_element = slider_cart.querySelector('.slider-cart__loyalty');
  const loyalty_member_element = slider_cart.querySelector('.slider-cart__loyalty-progress-widget');

  if (mb_element) {
    max_height = `${max_height} - ${getElementHeightWithMargins(mb_element)}px`;
    // console.log('1/ max_height', max_height);
  }

  if (discount_element) {
    max_height = `${max_height} - ${getElementHeightWithMargins(discount_element)}px + 60px`; // 60 to allow a line of discount flags below
    // console.log('2/ max_height', max_height);
  }

  if (totals_element) {
    max_height = `${max_height} - ${getElementHeightWithMargins(totals_element)}px`;
    // console.log('3/ max_height', max_height);
  }

  if (buttons_element) {
    max_height = `${max_height} - ${getElementHeightWithMargins(buttons_element)}px`;
    // console.log('4/ max_height', max_height);
  }

  if (loyalty_guest_element) {
    max_height = `${max_height} - ${getElementHeightWithMargins(loyalty_guest_element)}px`;
    // console.log('5/ max_height', max_height);
  }

  if (loyalty_member_element) {
    max_height = `${max_height} - 150px`;
    // console.log('6/ max_height', max_height);
  }

  max_height = `${max_height} - 45px`; // Afterpay

  if (cart_content_element) {
    const style = window.getComputedStyle(cart_content_element);
    const paddingTop = parseFloat(style.paddingTop) || 0;
    const paddingBottom = parseFloat(style.paddingBottom) || 0;
    max_height = `${max_height} - ${paddingTop + paddingBottom}px`; // Include top and bottom paddings
    // console.log('7/ max_height (with paddings)', max_height);
  }

  if (!is_mobile) {
    max_height = `${max_height} + 30px`; // General adjustments
  }

  max_height = `calc(${max_height})`;
  // console.log('8/ max_height', max_height);
  
  slider_cart_products.style.maxHeight = max_height;
};

const openSliderCart = () => {
  closeMobileNav();
  // cartPosition();
  $('html').addClass('slider-cart-opened');
  $('[data-full-overlay]').addClass('active').addClass('white');

  $('[data-parent="account"]').removeClass('keep-opened');
  $('[data-parent="search"]').removeClass('keep-opened');
  $('[data-handle="account"] a').attr('aria-expanded', false);
  $('[data-handle="search"] a').attr('aria-expanded', false);
  // closeSubnav();

  // Refresh subtotal due to a bug coming from a 3rd party app
  // window.setTimeout(() => {
  //   $('[data-subtotal]').html(formatMoney(window.cart.total_price, theme.moneyFormat));
  //   // zonos.displayCurrency();
  // }, 100);

  // if (window.theme.breakpoints.current === 'mobile') {
    // disableBodyScroll($('[data-cart-nav]')[0]);
  // }

  // [ADA] Move focus to opened cart
  $('[data-slider-cart]').trigger('focus');
  if ($('[data-slider-cart-mb]').length) { $('[data-slider-cart-mb]').attr('tabindex', 0); }
  if ($('.sc-mb__title').length) { $('.sc-mb__title').attr('tabindex', 0); }
  if ($('.sc-mb__description').length) { $('.sc-mb__description').attr('tabindex', 0); }
  if ($('.shipping-bar__message').length) { $('.shipping-bar__message').attr('tabindex', 0); }
  if ($('.slider-cart__item-title').length) { $('.slider-cart__item-title').attr('tabindex', 0); }
  if ($('.slider-cart__item-price').length) { $('.slider-cart__item-price').attr('tabindex', 0); }
  if ($('.slider-cart__item-color').length) { $('.slider-cart__item-color').attr('tabindex', 0); }
  if ($('.slider-cart__item-size').length) { $('.slider-cart__item-size').attr('tabindex', 0); }
  if ($('.slider-cart__subtotal').length) { $('.slider-cart__subtotal').attr('tabindex', 0); }
  if ($('.slider-cart__buttons').length) { $('.slider-cart__buttons').attr('tabindex', 0); }
  if ($('.slider-cart__loyalty').length) { $('.slider-cart__loyalty').attr('tabindex', 0); }

  productsAreaHeight();

  // The scrollbar isn't there anymore, some calculated sections such as the carousels need to have their width reajusted
  $(window).trigger('resize');
};

const closeSliderCart = () => {
  $('html').removeClass('slider-cart-opened');
  $('[data-full-overlay]').removeClass('active').removeClass('white');

  // [ADA] Close button has been called
  $('[data-slider-cart-close]').attr('aria-pressed', true);

  // The scrollbar comes back, some calculated sections such as the carousels need to have their width reajusted
  $(window).trigger('resize');
};

const sliderCart = async () => {
  // $(window).on('scroll', () => {
  //   cartPosition();
  // });

  // User gets redirected from /cart, open the cart
  if (window.location.hash === '#cart') {
    openSliderCart();
  }

  // Submit with ajax instead of regular form action
  $(document).on('submit', 'form[action^="/cart/add"]', async (e) => {
    e.preventDefault();
    // const $item = $(e.currentTarget);

    if ($('body').hasClass('edit-cart')) {
      $('[data-quickview-update]').attr('disabled', true);
      $('[data-quickview-update] span').text('Updating...');

      const updates = {};
      // let qty = parseInt($('[data-quickview-update]').data('initial-variant-qty'), 10);
      updates[$('[data-quickview-update]').data('initial-variant-id')] = 0;
      await updateCartQuantity(updates);
    }

    await addToCart($(e.currentTarget));

    // [ADA] Move focus to opened cart
    $('[data-slider-cart]').trigger('focus');
  });

  $(document).on('click', '[data-cart-nav]', () => {
    if ($('body').hasClass('template-cart')) {
      return;
    }

    if ($('.slider-cart-opened').length) {
      closeSliderCart();
    } else {
      openSliderCart();
    }
  });

  $(document).on('click', '[data-slider-cart-close]', () => {
    closeSliderCart();
  });

  // [ADA] Close button has been called
  $(document).on('keypress', '[data-slider-cart-close]', (e) => {
    const key = e.which;

    // Enter / spacebar
    if (key === 13 || key === 32) {
      closeSliderCart();
    }
  });

  // ADA
  $(document).on('keypress', '[data-slider-cart]', (e) => {
    const key = e.which;
  
    // Escape
    if (key === 27) {
      closeSliderCart();
      $('[data-main-nav]').trigger('focus');
    }
  });

  await updateCart();
  const CartDrawerDiscountObj = new CartDrawerDiscount();
  CartDrawerDiscountObj.init();
};

export {
  sliderCart,
  openSliderCart,
  closeSliderCart,
};
